import api from "../api";

const getGabaritos = async function () {
  return api.get("/api/Gabaritos");
};

const gabaritoService = {
  getGabaritos,
};

export default gabaritoService;
